/* AramCrochet: dress up the menu drawer (3-bar menu).
   Adds the brand strip on top, an icon + arrow to every link, and the lower block
   (occasions, beginner card, quick links) in place of the theme's product list.
   The markup comes from <template id="ac-drawer-tpl">, rendered by Liquid in the head. */
(function () {
  function pick(a) {
    var k = ((a.getAttribute('href') || '') + ' ' + a.textContent).toLowerCase();
    if (/(^\/\s|home)/.test(k) || a.getAttribute('href') === '/') return 'home';
    if (/best/.test(k)) return 'best';
    if (/collection|shop/.test(k)) return 'collection';
    if (/review/.test(k)) return 'review';
    if (/contact|help/.test(k)) return 'contact';
    return 'default';
  }
  var ARROW = '<span class="ac-dx-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span>';

  function init() {
    var tpl = document.getElementById('ac-drawer-tpl');
    if (!tpl) return;
    document.querySelectorAll('.menu-drawer').forEach(function (dr) {
      var frag = tpl.content;
      var nav = dr.querySelector('.menu-drawer__navigation');
      var brand = frag.querySelector('.ac-db');
      if (brand && nav && !dr.querySelector('.ac-db')) nav.parentNode.insertBefore(brand.cloneNode(true), nav);

      dr.querySelectorAll('a.menu-drawer__menu-item--mainlist').forEach(function (a) {
        if (a.querySelector('.ac-dx-ico')) return;
        var ico = frag.querySelector('.ac-dx-ico[data-k="' + pick(a) + '"]');
        if (ico) a.insertBefore(ico.cloneNode(true), a.firstChild);
        a.insertAdjacentHTML('beforeend', ARROW);
      });

      var extras = frag.querySelector('.ac-dx');
      if (extras && !dr.querySelector('.ac-dx')) {
        var util = dr.querySelector('.menu-drawer__utility-links');
        var node = extras.cloneNode(true);
        var n = dr.querySelectorAll('.menu-drawer__menu > li').length;
        node.style.setProperty('--menu-drawer-animation-index', n + 1);
        if (util) util.parentNode.insertBefore(node, util); else dr.appendChild(node);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  /* the header can re-render its drawer (menu/drawer switch, resize); dress it again whenever that happens
     and right before it opens */
  document.addEventListener('toggle', init, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header__icon--menu, summary, [on\\:click*="header-drawer"]')) init();
  }, true);
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; init(); });
    }).observe(document.getElementById('header-group') || document.body, { childList: true, subtree: true });
  }
})();
